
import {RequestDetailEdit} from "../../../models/requestDetailEdit";
import {RequestMaterials} from "../../../models/requestMaterials";
import {RequestAssignedMaterialToPackage} from "../../../models/requestAssignedMaterialToPackage";


export class RequestLetterEditController implements ng.IController {

    requestDetailEdit: RequestDetailEdit;

    $onInit() { }

    dimension(len: string, width: string, height: string, uom: string): string {
        return len + 'L x' + width + 'W x' + height + 'H ' + uom;
    }

    isPackageTypeEnvelope(packageType: string): boolean {
        if (packageType !== undefined && packageType !== null && packageType.toLocaleLowerCase() === "envelope")
            return true;

        return false;
    }


    getRequestedDeliveryDate(val : any): string {
        if (val !== undefined && val !== null) {
            return this.getFormattedDate(new Date(val.toLocaleString()));
        }
        return "";
    }

    getShipmentReadyDate(val: any): string {
        if (val !== undefined && val !== null) {
            return this.getFormattedDate(new Date(val.toLocaleString()));
        }
        return "";
    }

    showAssetColumn(): boolean {

        if (this.shipmentNotUndefined() && this.requestDetailEdit.requestDetail.requestShipment.isAsset === true) {
            return true;
        }
        return false;
    }

    shipmentNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined && this.requestDetailEdit !== null && this.requestDetailEdit.requestDetail !== null &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment !== undefined &&
        this.requestDetailEdit.requestDetail.requestShipment !== null;
    }

    consigneeNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined && this.requestDetailEdit !== null && this.requestDetailEdit.requestDetail !== null &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestConsignee !== undefined &&
            this.requestDetailEdit.requestDetail.requestConsignee !== null;
    }

    pickupDetailsNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined && this.requestDetailEdit !== null && this.requestDetailEdit.requestDetail !== null &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestPickupDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestPickupDetail !== null;
    }

    private getFormattedDate(dateValuetobeFormatted: Date): string {
        var monthValue = dateValuetobeFormatted.getMonth() + 1;
        var dateValue = dateValuetobeFormatted.getDate();
        var yearValue = dateValuetobeFormatted.getFullYear();
        return monthValue + "/" + dateValue + "/" + yearValue;
    }

    defaultValue(value: string): string {
        return (value === null || value === undefined) ? "--" : value;
    }

    defaultValueCharges(value: string): string {
        return (value === null || value === undefined) ? "--" : "$" + value;
    }

    getChargeToConsigneeValue(val : any): string {

        if (val !== undefined &&
            val !== null &&
            val) {
            return "Yes";
        } else if (val !== undefined &&
            val !== null &&
            !val) {
            return "No";

        }
        return "";
    }

  
    getTotalQuantityAssignedForPackage(packageRecordNumber: number): number {
       
        var totalPackageQty: number = 0;

        for (let assignedMaterial of this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage) {

            if (assignedMaterial.requestPackages !== undefined &&
                assignedMaterial.requestPackages.filter(o => (
                        o.recordNumber !== undefined &&
                        o.recordNumber !== null &&
                        o.recordNumber === packageRecordNumber &&
                        o.quantity !== undefined &&
                        o.quantity !== null &&
                        o.quantity > 0 &&
                        !o.isDeleted))
                    .length >
                0)
            {
                for (let rqPackages of assignedMaterial.requestPackages) {
                    totalPackageQty = totalPackageQty +
                        ((rqPackages !== undefined && rqPackages !== null &&
                        rqPackages.quantity !== undefined && rqPackages.quantity !== null && rqPackages.quantity > 0 && !rqPackages.isDeleted && rqPackages.recordNumber ===  packageRecordNumber)
                        ? angular.copy(Number(rqPackages.quantity))
                        : 0);
                }
            }
        }

        return  Number(totalPackageQty.toFixed(2));
    }


    isPackageAssignedToMaterial(packageRecordNumber: number, materialRecordNumber: number): boolean {


        if (this.requestDetailEdit !== undefined && this.requestDetailEdit.requestMaterial !== undefined &&
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined && this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[materialRecordNumber] !== undefined &&
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[materialRecordNumber].requestPackages !== undefined &&
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[materialRecordNumber].requestPackages
            .filter(o => (
                o.recordNumber !== undefined &&
                    o.recordNumber !== null &&
                    o.recordNumber === packageRecordNumber &&
                    o.quantity !== undefined &&
                    o.quantity !== null &&
                    o.quantity > 0 &&
                    !o.isDeleted))
            .length >
            0) {

            return true;
        }
        return false;
    }

    getQuantityAssignedToMaterialForPackage(packageRecordNumber: number, materialRecordNumber: number): number {

        var qty: number = 0;
        if (this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestMaterial !== undefined &&
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined &&
            this.requestDetailEdit.requestMaterial
            .requestAssignedMaterialToPackage[materialRecordNumber] !==
            undefined &&
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[materialRecordNumber]
            .requestPackages !==
            undefined) {

            qty = angular.copy(this.requestDetailEdit.requestMaterial
                .requestAssignedMaterialToPackage[materialRecordNumber]
                .requestPackages
                .filter(o => (
                    o.recordNumber !== undefined &&
                        o.recordNumber !== null &&
                        o.recordNumber === packageRecordNumber &&
                        o.quantity !== undefined &&
                        o.quantity !== null &&
                        o.quantity > 0 &&
                        !o.isDeleted))[0].quantity);
        }

        return qty;
    }




    isConsigneeParameterNotNull(consigneeeParameter: string): boolean {
        return (consigneeeParameter !== undefined && consigneeeParameter !== null && consigneeeParameter.length > 0);
    }

    ischargeToConsigneeEnable(chargeToConsigneee: string): boolean {
        return (chargeToConsigneee === "Yes");
    }
    isOtherLocationExists(location: string): boolean {
        return (location === "Other");
    }

    isOtherLocationAndValueOfParameterExist(location: string, parameter: string): boolean {
        if (location === "Other") {
            if (parameter !== undefined && parameter !== null && parameter.length > 0) {
                return true;
            }
        }
        return false;
    }

    getTotalCost(pkgRecordNumber: number, matRecordNumber : number, costPerUnit: number): string {
        var quantity: number = null;

        quantity = angular.copy(this.getQuantityAssignedToMaterialForPackage(pkgRecordNumber, matRecordNumber));
        
        if (quantity !== undefined && quantity !== null && costPerUnit !== undefined && costPerUnit !== null) {
            var total = quantity * costPerUnit;
            return '$' + total.toFixed(2);
        } else {
            return '';
        }
    }

    getNetWeight(pkgRecordNumber: number, matRecordNumber: number, weight: number): string {
        var quantity: number = null;

        quantity = angular.copy(this.getQuantityAssignedToMaterialForPackage(pkgRecordNumber, matRecordNumber));

        if (quantity !== undefined && quantity !== null && weight !== undefined && weight !== null) {
            var netWt = quantity * weight;
            return netWt.toFixed(2);
        } else {
            return '';
        }
    }

    getpickupLoactionCityRegionCodeAndPostalCode(pickupLocationCity:string, pickupLocationRegion:string,pickupLocationPostalCode:string ): string {
        return pickupLocationCity + ", " + pickupLocationRegion + " " + pickupLocationPostalCode;
    }

    getAllMaterialsCost(): string {
        let totalMaterialsCost = 0;
        if (this.requestDetailEdit !== undefined && this.requestDetailEdit.requestMaterial !== undefined && this.requestDetailEdit.requestMaterial.requestMaterials !== undefined )
            for (let i = 0; i < this.requestDetailEdit.requestMaterial.requestMaterials.length; i++) {

                totalMaterialsCost += angular.copy((this.requestDetailEdit.requestMaterial.requestMaterials[i]
                    .costPerUnit *
                    this.requestDetailEdit.requestMaterial.requestMaterials[i].quantity));

            }
        return '$' + totalMaterialsCost.toFixed(2);
        
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/requestLetterEdit/controllers/requestLetterEditController.ts
 **/